import React, {useContext, useEffect} from "react";
import Snackbar from '@mui/material/Snackbar';
import {AppContext} from "../../AppContext";
import Grow from '@mui/material/Grow';
import {Alert} from "@mui/material";




const Toaster = () =>{
    const {notificationService} = useContext(AppContext);

    const [open, setOpen] = React.useState(false);
    const [transition, setTransition] = React.useState(undefined);
    const [message, setMessage] = React.useState("");
    const [messageType, setMessageType] = React.useState();


    const handleClose = () => {
        setOpen(false);
        notificationService.removeNotice();
    };



    useEffect(() => {
        if(notificationService.notice) {
            setTransition(() => Grow);
            setOpen(true);
            setMessage(notificationService.notice.message);
            setMessageType(notificationService.notice.status);
        }
    }, [notificationService.notice]);

    return (

        <Snackbar
            open={open}
            onClose={handleClose}
            TransitionComponent={transition}
            key={transition ? transition.name : ''}
        >
                <Alert onClose={handleClose} severity = {messageType} sx={{ width: '100%' }}>
                    {message}
                </Alert>
        </Snackbar>


    )

}

export default Toaster;
